import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  Grow,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { ListSkeleton } from "components/listSkeleton";
import moment from "moment";
import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTheme } from "redux/actions/programAction";
import { RootState } from "redux/store/store";
import { MenuProps } from "styles/global.styles";
import { ThemeForm } from "./ThemeForm";
import style from "./index.module.scss";

interface State {
  editing?: boolean;
  editItem?: any;
  lang: number;
}
export const languageType = [
  "defaultcontent",
  "en",
  "hi",
  "te",
  "gu",
  "ta",
  "ka",
  "mr",
  "it",
  "ru",
  "es",
  "fr",
  "pt",
  "de",
  "bn",
  "ml",
  "uk",
  "od",
  "enUs",
  "enAu",
  "pa",
  "ja"
];
export default function ThemeScreen(): ReactElement {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.program.programList);
  const languages = useSelector((state: RootState) => state.app.languages);
  console.log("State themes", state, languages);
  const initialState = {
    editing: false,
    editItem: null,
    lang: 1,
  };

  const [language, setLanguage] = useState<any>(1);
  const [currentIndex, setcurrentIndex] = useState(0);
  const [searchTheme, setsearchTheme] = useState("");
  const [searchData, setSearchData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [states, setStates] = useState<State>(initialState);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) =>
    setPage(newPage);
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    console.log("Hello", page, rowsPerPage);
    dispatch(getAllTheme(page, rowsPerPage));
  }, [language, dispatch, page, rowsPerPage]);

  const onClickBack = () => {
    dispatch(getAllTheme(page, rowsPerPage));
    setcurrentIndex(0);
    setStates({
      editing: false,
      editItem: null,
      lang: language,
    });
  };

  const renderThemeList = (data: any) => {
    return (
      <div>
        {data && data.length ? (
          <>
            <Grid
              style={{ backgroundColor: "transparent" }}
              className="d-flex py-2 pl-3 align-items-center"
            >
              <Grid className="d-flex flex-grow-1">
                <TextField
                  type="search"
                  fullWidth
                  variant="outlined"
                  placeholder="Search theme by title"
                  size="small"
                  onChange={e => {
                    setsearchTheme(e.target.value);
                    const filteredData = data.filter((item: any) =>
                      item.title[languageType[language - 1]]
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()),
                    );
                    console.log("Filtered Data", filteredData);
                    setSearchData(filteredData);
                  }}
                  className="mr-2"
                />
              </Grid>
              <Grid className="d-flex align-items-center">
                <IconButton
                  onClick={() => {
                    dispatch(getAllTheme(page, rowsPerPage));
                  }}
                  size="large"
                >
                  <Tooltip title="Refresh">
                    <RefreshIcon />
                  </Tooltip>
                </IconButton>
              </Grid>
            </Grid>
            <TableContainer style={{ maxHeight: "400px" }} className={style.scrollbar}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead sx={{ height: "50px" }}>
                  <TableRow style={{ fontWeight: "bold" }}>
                    <TableCell align="left">Title</TableCell>
                    <TableCell align="left">From date</TableCell>
                    <TableCell align="left">To date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(searchTheme !== "" ? searchData : data)
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item: any, x: any) => (
                      <React.Fragment key={x}>
                        <TableRow
                          sx={{ cursor: "pointer", height: "50px" }}
                          hover
                          onClick={() => {
                            setStates({
                              editing: true,
                              editItem: item,
                              lang: language,
                            });
                            setcurrentIndex(1);
                          }}
                        >
                          <TableCell align="left">
                            {item.title[languageType[language - 1]] ? (
                              item.title[languageType[language - 1]]
                            ) : (
                              <Chip variant="filled" label="Content not set for this language" />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {item.fromdate.seconds ? (
                              <>
                                {moment(
                                  new Date(
                                    (Number(item.fromdate.seconds) +
                                      Number(item.fromdate.nanos) * 10 ** -9) *
                                      1000,
                                  ),
                                ).format("DD MMM, hh:mm a")}
                              </>
                            ) : (
                              <Chip variant="filled" label="Content not set for this language" />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {item.todate.seconds ? (
                              <>
                                {moment(
                                  new Date(
                                    (Number(item.todate.seconds) -
                                      1 +
                                      Number(item.todate.nanos) * 10 ** -9) *
                                      1000,
                                  ),
                                ).format("DD MMM, hh:mm a")}
                              </>
                            ) : (
                              <Chip variant="filled" label="Content not set for this language" />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={Number(state.themeList.themes?.responsepageable?.totalcount)}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
              className={style.scrollbar}
            />
          </>
        ) : (
          <Box height={350}>
            <Grid
              container
              style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No live session to show
              </Typography>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Card className="mt-3 mb-5">
            <Grow
              in={currentIndex === 0}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 0 ? { timeout: 1000 } : {})}
            >
              <div>
                <Grid container className="align-items-center p-3" spacing={2}>
                  <Grid item>
                    <Typography variant="h6">All Themes</Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        console.log("Add Theme");
                        setcurrentIndex(1);
                        dispatch(getAllTheme(page, rowsPerPage));
                      }}
                    >
                      Add Theme
                    </Button>
                  </Grid>
                </Grid>

                <Grid item xs={6} sm={4} md={4} lg={3}>
                  <FormControl variant="outlined" className="m-3" fullWidth>
                    <InputLabel id="language-select">Language</InputLabel>
                    {languages && (
                      <Select
                        defaultValue=""
                        labelId="language-select"
                        value={language}
                        label="Language"
                        onChange={e => {
                          setLanguage(e.target.value as number);
                        }}
                        MenuProps={MenuProps}
                      >
                        {languages.map((lang: any, i: any) => (
                          <MenuItem key={i} value={lang.code}>
                            {lang.displayName}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Divider />
                <CardContent>
                  <Paper>
                    {state.themeList.loading
                      ? ListSkeleton()
                      : renderThemeList(state.themeList.themes?.themelistwithalllanguageList)}
                  </Paper>
                </CardContent>
              </div>
            </Grow>
            <Grow
              in={currentIndex === 1}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 1 ? { timeout: 1000 } : {})}
            >
              <ThemeForm
                editItem={states.editItem}
                isEditing={states.editing}
                lang={language}
                onClickBack={onClickBack}
                getAllThemeData={{
                  pageNumber: page,
                  pageSize: rowsPerPage,
                }}
              />
            </Grow>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
